<ng-container *ngIf="addresses?.total">
    &nbsp;<span class="badge badge-pill badge-info">{{ addresses.total }} addresses</span>
</ng-container>